import common from './common';
import home from './home';

export default { home, common }
